import { ModalController } from '@ionic/angular';
import { Component, ComponentFactoryResolver, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'src/app/classes/observable';
import { MfaActivateProccessComponent } from 'src/app/components/mfa-activate-proccess/mfa-activate-proccess.component';

@Component({
  selector: 'app-mfa-activate',
  templateUrl: './mfa-activate.page.html',
  styleUrls: ['./mfa-activate.page.scss'],
})
export class MfaActivatePage implements OnInit {
  @ViewChild('myHost', { static: true, read: ViewContainerRef }) myHost;

  constructor(public modalCtrl: ModalController,private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
    Observable.suscribe("modalMFADismiss",(data)=>{
      this.modalCtrl.dismiss(true);
    });
    Observable.suscribe("modalDismissMFA",(data)=>{
      this.modalCtrl.dismiss(true);
    });
    
    this.addComponent(MfaActivateProccessComponent);
  }

  addComponent(componentClass: Type<any>) {
    // Create component dynamically inside the ng-template
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentClass);
    const component = this.myHost.createComponent(componentFactory);
    
    console.log(component);
    // Push the component so that we can keep track of which components are created
    this.myHost.push(component);
  }

  validar() {
    return true;
  }
} 
